"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.CONNECTION_STATUS_UPDATE = void 0; // TODO: [P3] We should obsolete this action in favor of DIRECT_LINE/UPDATE_CONNECTION_STATUS.
//       But today, both actions behave differently, this one only dispatch after connected and not dispatched when disconnected.

var CONNECTION_STATUS_UPDATE = 'DIRECT_LINE/CONNECTION_STATUS_UPDATE';
exports.CONNECTION_STATUS_UPDATE = CONNECTION_STATUS_UPDATE;

function _default(connectionStatus) {
  return {
    type: CONNECTION_STATUS_UPDATE,
    payload: {
      connectionStatus: connectionStatus
    }
  };
}